// actions/core/ribbon.js

import { attachAuth } from '../../utils/authService';

export function ribbonHasErrored(bool) {
  return {
    type: 'RIBBON_HAS_ERRORED',
    hasErrored: bool
  };
}

export function ribbonIsLoading(bool) {
  return {
    type: 'RIBBON_IS_LOADING',
    isLoading: bool
  };
}

export function ribbonFetchDataSuccess(response) {
  return {
    type: 'RIBBON_FETCH_DATA_SUCCESS',
    response
  };
}

export function ribbonFetchData(host) {
  return (dispatch) => {
    dispatch(ribbonIsLoading(true));
    dispatch(ribbonHasErrored(false));
    fetch(host + 'catalog/ribbon', {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(ribbonFetchDataSuccess(result));
            dispatch(ribbonHasErrored(false));
            dispatch(ribbonIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(ribbonHasErrored(true));
            dispatch(ribbonIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(ribbonHasErrored(true));
      dispatch(ribbonIsLoading(false));
    });
  };
}